import { profilesApiClient as f } from "../api/index.js";
function c(e) {
  const { isError: i, isPending: o, isPaused: r, isSuccess: n, error: t, data: u, refetch: d } = f.v1.getV1ProfilesOwnerid.useQuery(
    {
      path: {
        ownerId: (e == null ? void 0 : e.userId) ?? ""
      }
    },
    {
      enabled: !(e != null && e.pause)
    }
  );
  return {
    isError: i,
    isPending: o,
    isPaused: r,
    isSuccess: n,
    error: t,
    data: u,
    refetch: d
  };
}
export {
  c as useUserProfile
};
